<template>
    <v-card width="100%">
        <v-card-text :style="{ maxHeight: maxHeight }">
            <v-row
                :style="{ maxHeight: maxHeight }"
                class="d-flex pb-4 px-6 pt-4"
            >
                <v-col
                    sm="12"
                    lg="5"
                    style="max-height: 20rem"
                    class="flex-shrink-1 pl-0"
                >
                    <CalcTitle
                        :title="title"
                        :description="description"
                        :calcId="calcId"
                    />
                </v-col>
                <v-spacer v-if="!goVertical"></v-spacer>
                <v-col
                    sm="12"
                    lg="6"
                    style="height: 20rem"
                    class="flex-shrink-0"
                >
                    <v-divider v-if="goVertical"></v-divider>
                    <CalcMetadata
                        :calc="calc"
                        :libraryVersion="libraryVersion"
                    />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script setup>
import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import CalcTitle from './calc-info/CalcTitle.vue'
import CalcMetadata from './calc-info/CalcMetadata.vue'

const props = defineProps(['calc', 'libraryVersion'])

const { name: displayName } = useDisplay()

const title = computed(() => props.calc.name)
const description = computed(() => props.calc.description)
const calcId = computed(() => props.calc.calcId)

const goVertical = computed(() => {
    switch (displayName.value) {
        case 'xs':
            return true
        case 'sm':
            return true
        case 'md':
            return true
        case 'lg':
            return false
        case 'xl':
            return false
    }
})

const maxHeight = computed(() => {
    if (goVertical.value) return '42rem'
    else return '22rem'
})
</script>
